<script setup lang="ts">
import { NGrid } from 'naive-ui'
import { useAttrs } from 'vue'

const props = withDefaults(defineProps<{
  cols?: number | string
  xGap?: number | string
  yGap?: number | string
  responsive?: 'self' | 'screen'
  itemResponsive?: boolean
  collapsed?: boolean
  collapsedRows?: number
  itemStyle?: any
  itemClass?: string
}>(), {
  cols: 1,
  xGap: 0,
  yGap: 0,
  responsive: 'self',
  itemResponsive: false,
  collapsed: false,
  collapsedRows: 1,
  itemStyle: undefined,
  itemClass: undefined,
})

const attrs = useAttrs()
</script>

<template>
  <NGrid
    :cols="cols"
    :x-gap="xGap"
    :y-gap="yGap"
    :responsive="responsive"
    :item-responsive="itemResponsive"
    :collapsed="collapsed"
    :collapsed-rows="collapsedRows"
    :item-style="itemStyle"
    :item-class="itemClass"
    v-bind="attrs"
  >
    <template #default>
      <slot />
    </template>
  </NGrid>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
